/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';

// Types
import { TBodyApi, TResponseApi } from 'shared/types';
import { TMutationConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const uploadPicture = (
	data: TBodyApi
): Promise<{
	id: string;
	response: TResponseApi;
}> => {
	return apiClient.post('/media', data);
};

type TUseUploadPictureOptions = {
	mutationConfig?: TMutationConfig<typeof uploadPicture>;
};

export const useUploadUserPrivatePicture = ({
	mutationConfig,
}: TUseUploadPictureOptions = {}) => {
	const { onSuccess, ...restConfig } =
		mutationConfig || {};

	const {
		mutate,
		isPending: isLoading,
		isSuccess,
		data,
	} = useMutation({
		mutationFn: uploadPicture,
		onSuccess: (...args) => {
			onSuccess?.(...args);
		},
		...restConfig,
	});

	return { mutate, isLoading, isSuccess, data };
};
